"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waiverFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
exports.waiverFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => uuid_1.v4()),
    boss_organization_id: Mocks.orgNgb.id,
    title: 'Test Waiver',
    body: '<p>test</p>',
    acceptance_text: 'I agree',
    user_id: 1,
    current_version_number: 1,
    created_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000,
});
